import 'classlist.js';
import debounce from 'debounce';

export default {
	init(selectorAttr='data-float-distance', toggleClass='floating') {
		let els = document.querySelectorAll('['+selectorAttr+']');
		if (els.length) {
			els.forEach(el => {
				let distance = el.getAttribute(selectorAttr);
				this.setUp(el,distance,toggleClass);
			});
		}
	},
	setUp(el, distance=100, toggleClass='floating') {
		let toggleFloatingClass = function() {
			let scrollTop  = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop >= distance) {
				el.classList.add(toggleClass);
			} else {
				el.classList.remove(toggleClass);
			}
		};

		['DOMContentLoaded', 'load', 'resize', 'scroll'].forEach(function(eventName) {
			window.addEventListener(eventName, debounce(toggleFloatingClass, 10, false));
		});
	}
}